import React from "react";

import { Input } from "./styles";

interface TimeFieldProps {
    value: string;
    onChange: (value: string) => void;
    disabled?: boolean;
    id?: string;
    className?: string;
}

/*
* Время в формате "ЧЧ:ММ" — нативный input[type=time]. Часы и минуты в контракте
* лежат числами, поэтому конвертацию делает фича: здесь только строка.
* */
export const TimeField = ({ value, onChange, disabled, id, className }: TimeFieldProps) => (
    <Input
        id={id}
        className={className}
        type="time"
        value={value}
        disabled={disabled}
        onChange={(event) => onChange(event.target.value)}
    />
);
